import type { FaireProductEntity } from "../../entity_types/product";

export const p_938pdphds7: FaireProductEntity = {
  token: "p_938pdphds7",
  type: "product",
  name: "Brass Wind Chime with bells & beads Buddha in Ring",
  brandToken: "b_pfe5z89pnk",
  brandName: "Vrinda",
  imageUrl:
    "https://cdn.faire.com/fastly/197a5e8438f487dd3d9eb4f0f32f1df948a881d2b8aec586e9251dc32a8fc451.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/43e26cdc6da78fada35a038bc0f535fe0d352f325267ce21264bfbd16ebb58df.jpeg",
    "https://cdn.faire.com/fastly/277f37fe7b66cdb3bc5a087def4b7ade64845abfefcdb47bb18cc0989be37b73.jpeg",
    "https://cdn.faire.com/fastly/5b710891934f52990e65db380968edc6b56e1f6c8fc3d1ec778d120577c316aa.jpeg",
  ],
  priceDollars: 6.24,
  description:
    '- Size: Approx. 12 Inches in length, 2" diameter\n- Design features a Buddha in a Ring with beads & bells',
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:56.535Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
